import { signalStore, type, withHooks, withState } from '@ngrx/signals';
import { eventGroup, on, withReducer } from '@ngrx/signals/events';
import { withTreeShakableDevTools } from '@shared/constants/store.features';
import type { ApplicationDeviceTypes } from '@3dsource/metabox-front-api';
import { BetaFeaturesStore } from '@features/beta-features/store/beta-features.store';
import { UserStore } from '@features/account/store/user.store';
import { getProcessingFilesFromLocalStorage } from '@shared/components/uploader/store/uploader.actions';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { MixPanelService } from '@shared/services/mix-panel.service';
import { PreventPinchZoomService } from '@shared/services/prevent-pinch-zoom.service';
import { NavigationService } from '@shared/services/navigation.service';
import { NetworkStatusService } from '@shared/services/network-status.service';

interface AppStore {
  deviceType: ApplicationDeviceTypes;
}

const initialState: AppStore = {
  deviceType: 'deviceTypeAuto',
};

export const app = eventGroup({
  source: 'APP',
  events: {
    deviceType: type<{ deviceType: ApplicationDeviceTypes }>(),
  },
});

export const AppStore = signalStore(
  { providedIn: 'root' },
  withTreeShakableDevTools('app'),
  withState(initialState),
  withReducer(
    on(app.deviceType, ({ payload: { deviceType } }) => ({ deviceType })),
  ),
  withHooks({
    onInit() {
      inject(UserStore).getUserFromLocalStorage$();
      inject(BetaFeaturesStore).getBetaFeaturesFromLocalStorage$();
      inject(Store).dispatch(getProcessingFilesFromLocalStorage());
      inject(NavigationService).init();
      inject(PreventPinchZoomService).init();
      inject(MixPanelService).init();
      inject(NetworkStatusService).init();
    },
  }),
);
